import { Summary } from './summaryTypes';
import { AddToBagStateEnum } from '@inter-ikea-kompis/component-add-to-bag';
import { ShareDesignCardStateEnum } from '@inter-ikea-kompis/component-share-design-card';
import ZipInCardStateEnum from '@inter-ikea-kompis/component-zip-in/lib/enums/ZipInCardStateEnum.js';
import { SendByEmailStateEnum } from '@inter-ikea-kompis/component-send-by-email';
import { applicationSettings } from '../../settings/application';
import platform from '../../util/platform';

const defaultState: Summary = {
  locale: applicationSettings.locale,
  storeId: applicationSettings.storeId,
  shoppingItems: [],
  storeAvailabilities: [],
  sceneImage: '',
  designLink: '',
  confirmationCardType: null,
  currentConfiguration: null,
  addUnavailableProductsToList: false,
  failedShoppingItems: null,
  modal: {
    showModal: false,
    modalType: undefined,
  },
  states: {
    addToList: AddToBagStateEnum.default,
    addToCart: AddToBagStateEnum.default,
  },
  homeDelivery: {
    state: ZipInCardStateEnum.default,
    zipCode: '',
    zipAvailabilities: null,
  },
  shareDesignCard: {
    state: ShareDesignCardStateEnum.default,
    autocomplete: false,
    showGetLink: true,
    // E-mail
    showSendByEmail: true,
    sendByEmailState: SendByEmailStateEnum.default,
    // Copy design code
    showCopyDesignCodeButton: !platform.isKiosk,
    // Copy design link
    showCopyLink: true,
  },
  financingOptions: null,
};

export default defaultState;
